export const PrimaryButton = ({ busy, label, testId, ...props }) => (
  <button className="rs-prominent flex w-full items-center justify-center gap-2" data-testid={testId} {...props}>
    {busy && <span className="rs-spinner" />}
    <span>{label}</span>
  </button>
);

export const Segment = ({ options, value, onChange, testId, className = "" }) => (
  <div className={`rs-segment grid ${className}`} style={{ gridTemplateColumns: `repeat(${options.length}, 1fr)` }} data-testid={`${testId}-toggle`}>
    {options.map(([v, label]) => (
      <button key={v} data-active={value === v} data-testid={`${testId}-${v}-btn`} onClick={() => onChange(v)}>{label}</button>
    ))}
  </div>
);

export const pasteFromClipboard = async (setter, append = false) => {
  try {
    const text = await navigator.clipboard.readText();
    if (text) setter((prev) => (append && prev.trim() ? `${prev.trim()}\n${text}` : text));
  } catch {}
};
